import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Hero() {
  return <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-123">
      {/* Parallax Background */}
      <div className="absolute inset-0 bg-fixed bg-cover bg-center z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80")'
    }} data-id="element-124" />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-charcoal/[0.63] z-10" data-id="element-125" />

      {/* Content */}
      <div className="container mx-auto px-6 relative z-20 text-center mt-20" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl mx-auto" data-id="element-127">
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-white uppercase tracking-widest leading-tight mb-6 font-bold" style={{
          textShadow: '0 2px 20px rgba(0,0,0,0.6)'
        }} data-id="element-128">
            Your Home.
            <br data-id="element-129" />
            Your Future.
            <br data-id="element-130" />
            Your Move.
          </h1>
          <p className="font-body text-lg md:text-xl text-white/90 mb-10 max-w-2xl mx-auto font-semibold" style={{
          textShadow: '0 2px 20px rgba(0,0,0,0.6)'
        }} data-id="element-131">
            Nathan Rance — Helping you find the perfect property with a
            personal, white-glove approach.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-132">
            <Button className="w-full sm:w-auto bg-gold hover:bg-gold-dark text-charcoal font-semibold rounded-none px-8 h-14 text-base" data-id="element-133">
              View Listings
            </Button>
            <Button variant="outline" className="w-full sm:w-auto border-white text-white hover:bg-white hover:text-charcoal rounded-none px-8 h-14 text-base bg-transparent" data-id="element-134">
              Contact Nathan
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}